import { useState, useEffect } from "react";

const CURRENCIES = [
  { code: "INR", symbol: "₹", name: "Indian Rupee", flag: "🇮🇳" },
  { code: "USD", symbol: "$", name: "US Dollar", flag: "🇺🇸" },
  { code: "GBP", symbol: "£", name: "British Pound", flag: "🇬🇧" },
  { code: "EUR", symbol: "€", name: "Euro", flag: "🇪🇺" },
  { code: "AUD", symbol: "A$", name: "Australian Dollar", flag: "🇦🇺" },
  { code: "CAD", symbol: "C$", name: "Canadian Dollar", flag: "🇨🇦" },
  { code: "NZD", symbol: "NZ$", name: "New Zealand Dollar", flag: "🇳🇿" },
  { code: "CHF", symbol: "Fr", name: "Swiss Franc", flag: "🇨🇭" },
];

export { CURRENCIES };

export default function useCurrency() {
  const [currency, setCurrency] = useState("INR");
  const [rates, setRates] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchRates() {
      try {
        // Free API — no key needed, 1500 req/month
        const res = await fetch("https://api.frankfurter.app/latest?from=INR&to=USD,GBP,EUR,AUD,CAD,NZD,CHF");
        if (res.ok) {
          const data = await res.json();
          setRates(data.rates || {});
        }
      } catch (err) {
        console.warn("Exchange rate fetch failed, using estimates:", err);
        // Fallback approximate rates (INR base)
        setRates({ USD: 0.012, GBP: 0.0095, EUR: 0.011, AUD: 0.018, CAD: 0.016, NZD: 0.020, CHF: 0.011 });
      } finally {
        setLoading(false);
      }
    }
    fetchRates();
  }, []);

  const convert = (amountINR) => {
    if (currency === "INR") return amountINR;
    const rate = rates[currency];
    if (!rate) return amountINR;
    return Math.ceil(amountINR * rate);
  };

  const format = (amountINR) => {
    const cur = CURRENCIES.find(c => c.code === currency);
    const converted = convert(amountINR);
    return `${cur?.symbol || "₹"}${converted.toLocaleString()}`;
  };

  return { currency, setCurrency, convert, format, loading, CURRENCIES };
}